import React from 'react';
import { Switch } from '@buildoutinc/blueprint-react/ui/Switch';

interface Props {
  checked: boolean;
  label: string;
  onChange: (checked: boolean) => void;
}

export default function BetaToggleInput({ checked, label, onChange }: Props) {
  return (
    <div className="d-flex align-items-center mt-3">
      <Switch checked={checked} size="lg" onCheckedChange={onChange} />
      <p className="m-0 ms-3">{label}</p>
    </div>
  );
}
